// Copied from packages/supergraph/structuredContent/utils.ts because the Tailwind
// graph may not import @ria-client/ui. This duplicates logic that NWA-3985 was
// meant to move into @ria-client/content-domain. Reconcile when 3985 lands.
import type {
  StructuredContent,
  StructuredContentDocument,
} from '@ria-client/supergraph/structuredContent/types';

export type { StructuredContent, StructuredContentDocument };

export type NodeProps<T extends Record<string, unknown>> = StructuredContentDocument<T>;

export const isStructuredContent = (section: unknown): section is StructuredContentDocument => {
  return (
    section !== null &&
    typeof section !== 'undefined' &&
    typeof section === 'object' &&
    'type' in section &&
    'version' in section &&
    'props' in section
  );
};

function traverseStructuredContent(
  doc: StructuredContentDocument,
  visitor: (node: StructuredContentDocument) => boolean,
): void {
  const traverseNode = (node: StructuredContentDocument): boolean => {
    const shouldContinue = visitor(node);
    if (!shouldContinue) return false;

    const children = node.props?.children;
    if (!children) return true;

    const childrenArray = Array.isArray(children) ? children : [children];

    for (const child of childrenArray) {
      if (isStructuredContent(child) && !traverseNode(child)) return false;
    }

    return true;
  };

  traverseNode(doc);
}

export function findNodeByType(
  doc: StructuredContentDocument,
  nodeType: string,
): StructuredContentDocument | null {
  let found: StructuredContentDocument | null = null;

  traverseStructuredContent(doc, node => {
    const matches = node.type === nodeType;

    if (matches && !found) {
      found = node;
      return false;
    }
    return true;
  });

  return found;
}

export function findAllNodesByType(
  doc: StructuredContentDocument,
  nodeType: string,
): StructuredContentDocument[] {
  const results: StructuredContentDocument[] = [];

  traverseStructuredContent(doc, node => {
    const matches = node.type === nodeType;

    if (matches) results.push(node);
    return true;
  });

  return results;
}
